import module from 'colaborador/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class ColaboradorPrestamosExternosPrestamo {
  descuentoId
  idProyecto

  constructor($q, ColaboradorPrestamoExterno) {
    this.$q = $q;
    this.colaboradorPrestamoExternoService = ColaboradorPrestamoExterno
  }

  $onInit() {
    this.promise = this.colaboradorPrestamoExternoService.get(this.descuentoId)
    .then(({data}) => (this.data = data))
    .then(() => (this.desglose = orderBy(this.data.desglose, ['desgloseFechaFinal'], ['asc'])))
  }

  cerrar() {
    this.onClose()
  }

  modificar() {
    this.accion="ACTUALIZAR";
    this.texto = "Plazos actualizados exitosamente.";
    this.modificando = true;
  }

}

module.component('colaboradorPrestamosExternosPrestamo', {
  controller: ColaboradorPrestamosExternosPrestamo,
  template,
  bindings: {
    descuentoId: '<',
    idProyecto: '<',
    onClose: '&'
  }
})


// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/prestamo/component.js